// logged-out state => status will change from `pending` to `resolved` and `userSubscription` will remain `undefined`
// logged-in state => status will change from `pending` to `resolved` or `failed` after fetching and updating `userSubscription` in the context
var UserSubscriptionStatesEnum = /*#__PURE__*/function (UserSubscriptionStatesEnum) {
  UserSubscriptionStatesEnum["Pending"] = "pending";
  UserSubscriptionStatesEnum["Resolved"] = "resolved";
  UserSubscriptionStatesEnum["Failed"] = "failed";
  return UserSubscriptionStatesEnum;
}({});
var RestoreSubscriptionErrorsEnum = /*#__PURE__*/function (RestoreSubscriptionErrorsEnum) {
  RestoreSubscriptionErrorsEnum["SubscriptionNotCancelled"] = "subscription_not_cancelled";
  RestoreSubscriptionErrorsEnum["MarketNotSupported"] = "market_not_supported";
  RestoreSubscriptionErrorsEnum["PaymentMethodUpdateRequired"] = "payment_method_update_required";
  RestoreSubscriptionErrorsEnum["SubscriptionExpired"] = "subscription_expired";
  RestoreSubscriptionErrorsEnum["InvalidOrder"] = "invalid_order";
  return RestoreSubscriptionErrorsEnum;
}({});
var CancelSubscriptionErrorsEnum = /*#__PURE__*/function (CancelSubscriptionErrorsEnum) {
  CancelSubscriptionErrorsEnum["MarketNotSupported"] = "market_not_supported";
  CancelSubscriptionErrorsEnum["InvalidOrder"] = "invalid_order";
  return CancelSubscriptionErrorsEnum;
}({});

// add payment method, restart / switch

export { CancelSubscriptionErrorsEnum as C, RestoreSubscriptionErrorsEnum as R, UserSubscriptionStatesEnum as U };
//# sourceMappingURL=userSubscriptionModel-47e03fd5.js.map
